// 사업자 입력 정보
export const bizUserInfoConst = [
  {
    title: '사업자명',
    name: 'bizName',
    placeholder: '사업자명을 입력해주세요.',
    isNecessary: true,
    content: '',
    error: '',
    max: 50,
  },
  {
    title: '사업자 번호',
    name: 'bizNum',
    placeholder: '사업자 번호를 입력해주세요.',
    isNecessary: true,
    isAction: true,
    content: '',
    error: '',
    success: false,
    buttonDisabled: false,
    max: 12,
  },
  {
    title: '업태',
    name: 'bizType',
    placeholder: '업태를 입력해주세요.',
    isNecessary: true,
    isMultiple: true,
    content: '',
    error: '',
    max: 30,
  },
  {
    title: '종목',
    name: 'bizItem',
    placeholder: '종목을 입력해주세요.',
    isNecessary: true,
    isMultiple: true,
    content: '',
    error: '',
    max: 30,
  },
  {
    title: '주소',
    content: '',
    placeholder: '주소 검색을 선택해주세요.',
    isNecessary: true,
    isAction: true,
    name: 'address',
    disabled: true,
    error: '',
    max: 100,
  },
  {
    title: '사업자 등록증',
    name: 'bizLicense',
    placeholder: '파일 첨부를 선택해주세요. (pdf, jpg, png, 최대 5MB)',
    isNecessary: true,
    isAction: true,
    content: '',
    file: '',
    error: '',
    id: 'bizLifileUpload',
    disabled: true,
    isLoading: true,
  },
  {
    title: '대표자명',
    name: 'repName',
    placeholder: '대표자명을 입력해주세요.',
    isNecessary: true,
    content: '',
    error: '',
    max: 10,
  },
  {
    title: '대표 사업자 이메일',
    name: 'reqEmail',
    placeholder: '대표 사업자 이메일을 입력해주세요.',
    isNecessary: true,
    content: '',
    error: '',
    max: 50,
  },
  {
    title: '담당자 이름',
    name: 'contactName',
    placeholder: '담당자 이름을 입력해주세요.',
    isNecessary: true,
    isMultiple: true,
    content: '',
    error: '',
    max: 10,
  },
  {
    title: '부서/직책',
    name: 'deptPosition',
    placeholder: '부서/직책을 입력해주세요.',
    isMultiple: true,
    content: '',
    error: '',
    isNecessary: false,
    min: 0,
    max: 30,
  },
  {
    title: '담당자 연락처',
    name: 'contactPhone',
    placeholder: '- 없이 입력해주세요.',
    isNecessary: true,
    content: '',
    error: '',
    max: 13,
  },
];

export const addressSearchHeaders = [
  // {
  //   text: "NO",
  //   value: "no",
  // },
  {
    text: '주소',
    value: 'address',
  },
  {
    text: '우편번호',
    value: 'postcode',
  },
];

export const bizInfoRadioButtonsConst = [
  { label: '계정 이관 신청', checked: true },
  { label: '계정 이관 없이 바로 탈퇴', checked: false },
];

export const bizInfoExampleConst = {
  bizName: '아이나비시스템즈',
  bizNum: '114-86-02301',
  repName: '이은복',
  bizType: '지도제작업',
  bizItem: '프로그램 개발 및 정보 처리',
  address: '경기도 성남시 분당구 판교역로 240 (삼평동), 8층',
  reqEmail: 'impsbiz@inavi.kr',
  bizLicense: 'inavi.png',
};
